import { create } from "zustand";
import type { ExtractCapabilities } from "@tasduvar/shared";
import { api } from "../../api/client";

interface State { caps: ExtractCapabilities | null; loaded: boolean; load(): Promise<void> }
/** Sunucuda Gemini anahtarı var mı? Bir kez sorulur; API yoksa (statik yayın) kapalı kalır. */
export const useExtractCapabilities = create<State>((set, get) => ({
  caps: null, loaded: false,
  async load() {
    if (get().loaded) return;
    set({ loaded: true });
    try { set({ caps: await api<ExtractCapabilities>("GET", "/extract/capabilities") }); } catch { set({ caps: null }); }
  },
}));
